import { CtaShell } from "./cta-shell"
import type { CtaShellProps } from "./cta-types"

export type CardCtaProps = CtaShellProps

export function CardCta(props: CardCtaProps) {
  return <CtaShell {...props} placement="between-section" layout="card" />
}
